import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const Conversation = (store) => ({
  path: ROUTE.CONVERSATION,
  component: createLazyRouteComponent({
    store,
    loadComponent: () => import('./ConversationContainer'),
  }),
})

export default Conversation
